<!-- Add this link tag to your main index.html file (notfound.component.html is a partial) -->
<!-- Place this in the <head> section of src/index.html or your main HTML file -->

<div class="well">
  <div class="container-fluid">
    <div class="page-header mart5" style="text-align: center;">
      <h1>
        <i class="fa-solid fa-hand-point-down" aria-hidden="true"></i>&nbsp;
        <i class="fa-solid fa-hand-point-left" aria-hidden="true"></i>&nbsp;
        <i class="fa-solid fa-hand-point-right" aria-hidden="true"></i>&nbsp;
        <i class="fa-solid fa-hand-point-up" aria-hidden="true"></i>
      </h1>
      <h1>ERROR 404</h1>
      <p>Sorry, but the page you are looking for was not found. Please check the URL and try again.</p>
      <ul class="list-inline">
        <li>
          <p>
            <a href="/" class="lead">Go to Home page</a>
          </p>
        </li>
      </ul>
    </div>
  </div>
</div>
